export default __webpack_public_path__ + "static/media/Slide33.3db674b2.PNG";